import { TranslationModule } from './../translation.module';
import { NgModule } from "@angular/core";
import { WaitingComponent } from "./waiting/waiting.component";
import { PrimeNGModule } from "../primeng.module";
import { ConfirmPopupComponent } from './confirm-popup/confirm-popup.component';
import { ErrorBannerComponent } from './error-banner/error-banner.component';
import { SuccessBannerComponent } from './success-banner/success-banner.component';
import { InfoPopoverComponent } from './info-popover/info-popover.component';

@NgModule({
    declarations: [
        WaitingComponent,
        ConfirmPopupComponent,
        ErrorBannerComponent,
        SuccessBannerComponent,
        InfoPopoverComponent
    ],
    imports: [
        PrimeNGModule,
        TranslationModule
    ],
    exports: [
        WaitingComponent,
        ConfirmPopupComponent,
        ErrorBannerComponent,
        SuccessBannerComponent,
        InfoPopoverComponent
    ]
})
export class CommonComponentModule {

}